import React, { useState } from "react";
import { McIcon } from "@maersk-global/mds-react-wrapper/components-core";

// Simple sun/moon toggle; theme state + persistence lives in Analytics.js
// (single source of truth so `data-theme` on the page wrapper and this
// button's icon can never disagree).
const ThemeToggle = ({ theme, onToggle }) => {
  const isDark = theme === "dark";
  const [isHovered, setIsHovered] = useState(false);
  return (
    <button
      type="button"
      className="theme-toggle-btn"
      onClick={onToggle}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      title={isDark ? "Switch to light mode" : "Switch to dark mode"}
      aria-pressed={isDark}
    >
      <McIcon
        icon={isDark ? "sun" : "moon"}
        size="16"
        color={isHovered ? "var(--an-accent)" : "var(--an-text-muted)"}
      />
    </button>
  );
};

export default ThemeToggle;
